import Decorator from '../decorator'
import ObjectModelPropertyContainer from '../../mixins/objectModelPropertyContainer'
import {IObjectModel} from '../../interfaces/objectModelInterfaces'
import ObjectModelRelationContainer from "~/mixins/objectModelRelationContainer";
import ObjectModelRelationContainerBase from "~/mixins/objectModelRelationContainerBase";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";

export default class PublishedObjectModelDecorator extends ObjectModelRelationContainerBase(ObjectModelPropertyContainer(Decorator)) {
  updateFrom(json): this {
    super.updateFrom(json);
    this.loadObjectModelProperties(json.object_model_properties)
    this.loadObjectModelRelations(json.object_model_relations)
    return this;
  }

  private loadObjectModelProperties(properties: any[] = []) {
    this.object_model_properties = {}
    if (Array.isArray(properties)) {
      properties.forEach(prop => {
        let clonedProp = Object.assign({}, prop)
        this.object_model_properties[prop.client_id] = clonedProp
        if (prop.object_model_properties) {
          clonedProp.object_model_properties = {}
          prop.object_model_properties.forEach(childProp => {
            clonedProp.object_model_properties[childProp.client_id] = Object.assign({}, childProp)
          })
        }
      })
    }
  }

  private loadObjectModelRelations(relations: any[]) {
    this.object_model_relations = {}
    if (Array.isArray(relations)) {
      relations.forEach(rel => {
        this.object_model_relations[rel.client_id] = Object.assign({}, rel)
      })
    }
  }

  get objectModelRelationsArray(): ObjectModelRelation[] {
    return Object.values(this.object_model_relations);
  }
}